<div class="content-wrapper p-0">
	<div class="content-body">

		<app-content-header [contentHeader]="contentHeader"></app-content-header>


		<!-- Modal importacao -->
		<ng-template #modalBasic let-modal>
			<div class="modal-header">
				<h2 class="modal-title" id="myModalLabel1">Importar Chips</h2>
				<button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-label="Close">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div style="background-color: #F8F8F8; width: 100%;">
				<div style="max-width: 1200px; margin: 2% auto; width: 100%; background-color: #F8F8F8;">
					<div class="modal-body" tabindex="0" ngbAutofocus>

						<div *ngIf="contratoInterface.id_status != 2">
							<span for="basicInputFile">Informe os chips:</span>
							<textarea class="form-control" id="basicTextarea" rows="7" [(ngModel)]="bipados"
								placeholder="Registre os chips aqui."></textarea>
							<button class="btn btn-primary mt-1" (click)="EnviarBips()">
								<span *ngIf="spinnerImportar" class="spinner-border spinner-border-sm mr-1"></span>
								<span>Vincular</span>
							</button>
							<hr>
						</div>

						<div *ngIf="nao_vinculados_show">
							<div class="card">
								<!-- TABELA DE DADOS -->
								<section id="ngx-datatable-inline-editing">
									<div class="card-body pb-1">
										<h4 class="card-title">Resultado - Não Vinculados ❌</h4>
										<hr>
									</div>
									<!-- DATATABLE -->
									<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="500"
										columnMode="force" [reorderable]="false" [swapColumns]="false"
										[footerHeight]="50" [headerHeight]="0" [loadingIndicator]="spinnerImportar"
										style="box-shadow: none" [rows]="nao_vinculados" [scrollbarH]="true">

										<!-- COLUNA -->
										<ngx-datatable-column [sortable]="false">
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.status}}</span>
											</ng-template>
										</ngx-datatable-column>

									</ngx-datatable>
								</section>

								<button class="btn btn-primary mt-1" (click)="fecharResultadoVinculacao()">
									<span *ngIf="spinnerImportar" class="spinner-border spinner-border-sm mr-1"></span>
									<span>OK</span>
								</button>
							</div>
						</div>

						<div *ngIf="vinculados.length > 0">
							<div class="card">
								<!-- TABELA DE DADOS -->
								<section id="ngx-datatable-inline-editing">
									<div class="card-body pb-1">
										<h4 class="card-title">Resultado - Vinculados Com Sucesso ✔️</h4>
										<hr>
									</div>
									<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="500"
										columnMode="force" [reorderable]="false" [swapColumns]="false"
										[footerHeight]="50" [headerHeight]="0" [loadingIndicator]="spinnerImportar"
										style="box-shadow: none" [rows]="vinculados" [scrollbarH]="true">

										<!-- COLUNA -->
										<ngx-datatable-column [sortable]="false">
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.status}}</span>
											</ng-template>
										</ngx-datatable-column>

									</ngx-datatable>

								</section>
							</div>
						</div>
						<div *ngIf="nao_vinculados_show">
						</div>

						<div *ngIf="chipsVinculadosContrato.length == 0">
							<span style="color: red">Não há nenhum chip vinculado a este item!</span>
						</div>

						<div *ngIf="chipsVinculadosContrato.length > 0 && !nao_vinculados_show">
							<div class="card">
								<!-- TABELA DE DADOS -->
								<section id="ngx-datatable-inline-editing">
									<div class="card-body pb-1">
										<h4 class="card-title">Chips Vinculados neste Item</h4>
										<hr>
									</div>

									<!-- DATATABLE -->
									<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10"
										columnMode="force" [reorderable]="false" [swapColumns]="false"
										[footerHeight]="50" [headerHeight]="120"
										[loadingIndicator]="loadingIndicatorChipsVinculados" style="box-shadow: none"
										[rows]="chipsVinculadosContrato" [scrollbarH]="false">

										<!-- COLUNA -->
										<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<h4>N. ICCID</h4>
												<input type="search" placeholder="N. ICCID" class="ml-25 form-control"
													(keyup)="textFilter($event, 'icc_id')" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.icc_id}}</span>
											</ng-template>
										</ngx-datatable-column>

									</ngx-datatable>
								</section>
							</div>
						</div>
					</div>
				</div>
			</div>
		</ng-template>
		<!-- / Modal importacao-->

		<section class="invoice-add-wrapper">
			<div *ngIf="starting" class="card invoice-preview-card">
				<div class="card-body invoice-padding pb-2 pt-2">
					<div class="progress-wrapper">
						<ngb-progressbar [striped]="true" [animated]="true" [value]="100"></ngb-progressbar>
					</div>
				</div>
			</div>
			<div class="row invoice-add" *ngIf="!starting">

				<div class="col-xl-9 col-md-8 col-12">

					<div class="card invoice-preview-card">

						<form #cadastroForm="ngForm">
							<div class="card-body pb-1">
								<div class="mt-md-0 mt-2">
									<div *ngIf="contratoInterface.id_contrato != null"
										class="mb-2 mt-1 badge badge-primary">Número do Contrato:
										{{contratoInterface.num_contrato}}</div>
								</div>

								<h4>Informações do Contrato:</h4>

								<div class="row">
									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label for="basicSelect">Tipo *</label>
											<select [disabled]="contratoInterface.id_contrato != null"
												[disabled]="contratoInterface.id_status == 2"
												[(ngModel)]="contratoInterface.id_tipo" #Ref1="ngModel"
												[class.error]="!Ref1.valid && cadastroForm.submitted" name="id_tipo"
												class="form-control" id="basicSelect" required>
												<option value="1">Entrada</option>
												<option value="2">Saída</option>
											</select>
											<span *ngIf="cadastroForm.submitted && Ref1.invalid" class="invalid-form">
												<small class="form-text text-danger" *ngIf="Ref1.errors.required">
													Campo Obrigatório!
												</small>
											</span>
										</div>
									</div>

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label for="basicSelect">Status *</label>
											<select [(ngModel)]="contratoInterface.id_status" #Ref2="ngModel"
												[disabled]="true" [class.error]="!Ref2.valid && cadastroForm.submitted"
												name="id_status" class="form-control" id="basicSelect" required>
												<option value="1">Aberto</option>
												<option value="2">Finalizado</option>
												<option value="3">Cancelado</option>
											</select>
											<span *ngIf="cadastroForm.submitted && Ref2.invalid" class="invalid-form">
												<small class="form-text text-danger" *ngIf="Ref2.errors.required">
													Selecione uma opção!
												</small>
											</span>
										</div>
									</div>
								</div>
								<div class="row">
									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label for="basicSelect">Data de Fidelidade do Contrato *</label>
											<div class="input-group">
												<input class="form-control" placeholder="Selecione a data" required
													[disabled]="contratoInterface.id_status == 2" name="dt_fidelidade"
													[(ngModel)]="contratoInterface.dt_fidelidade" ngbDatepicker
													#dp="ngbDatepicker" />
												<button class="btn btn-outline-secondary bi feather icon-calendar"
													(click)="dp.toggle()" type="button"></button>
											</div>
										</div>
									</div>

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label for="basicSelect">Data do Contrato *</label>
											<div class="input-group">
												<input class="form-control" placeholder="Selecione a data"
													[disabled]="contratoInterface.id_status == 2" name="dt_contrato"
													[(ngModel)]="contratoInterface.dt_contrato" ngbDatepicker
													#dp2="ngbDatepicker" required />
												<button class="btn btn-outline-secondary bi feather icon-calendar"
													(click)="dp2.toggle()" type="button"></button>
											</div>
										</div>
									</div>

									<div class="col-md-6 col-12">
										<div class="form-group mb-2">
											<label for="basicSelect">Tempo Inadimplência/Bloqueio *</label>
											<select [(ngModel)]="contratoInterface.tempo_bloqueio" #Ref2="ngModel"
												[disabled]="true" [class.error]="!Ref2.valid && cadastroForm.submitted"
												name="tempo_bloqueio" class="form-control" id="basicSelect" required>
												<option value="15">15 dias</option>
												<option value="30">30 dias</option>
												<!-- <option value="2">Finalizado</option> -->
											</select>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>

					<div *ngIf="itensContrato.length > 0">
						<div class="card">
							<!-- TABELA DE DADOS -->
							<section id="ngx-datatable-inline-editing">
								<div class="card-body pb-1">
									<h4 class="card-title">Pedidos de Chip</h4>
									<br>
									<ngx-datatable class="material core-bootstrap" [rowHeight]="58" [limit]="10"
										columnMode="force" [reorderable]="false" [swapColumns]="false"
										[footerHeight]="50" [headerHeight]="50" [loadingIndicator]="starting"
										style="box-shadow: none" [rows]="itensContrato" [scrollbarH]="false">

										<!-- COLUNA -->
										<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<h4>Tipo de Item</h4>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold" *ngIf="row.id_tipo_item == 1">CHIP</span>
											</ng-template>
										</ngx-datatable-column>

										<!-- COLUNA -->
										<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<h4>Broker</h4>
												<input type="search" placeholder="N. ICCID" class="ml-25 form-control"
													(keyup)="textFilter($event, 'icc_id')" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.broker_nome == null ? '-' :
													row.broker_nome.toUpperCase()}}</span>
											</ng-template>
										</ngx-datatable-column>

										<!-- COLUNA -->
										<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<h4>Plano</h4>
												<input type="search" placeholder="N. ICCID" class="ml-25 form-control"
													(keyup)="textFilter($event, 'icc_id')" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.plano_nome == null ? '-' :
													row.plano_nome.toUpperCase()}}</span>
											</ng-template>
										</ngx-datatable-column>

										<!-- COLUNA -->
										<ngx-datatable-column name="Nome" prop="nome" [sortable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<h4>Operadora</h4>
												<input type="search" placeholder="N. ICCID" class="ml-25 form-control"
													(keyup)="textFilter($event, 'icc_id')" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<span class="font-weight-bold">{{row.nome_operadora == null ? '-' :
													row.nome_operadora.toUpperCase()}}</span>
											</ng-template>
										</ngx-datatable-column>


										<!-- COLUNA -->
										<ngx-datatable-column [width]="20" [sortable]="false">
											<ng-template ngx-datatable-cell-template let-rowIndex="rowIndex"
												let-value="value" let-row="row">
												<div class="d-flex align-items-center" style="float: right">
													<div ngbDropdown container="body">
														<button type="button" class="btn btn-primary btn-sm btn-add-new"
															(click)="modalOpen(modalBasic, row.id_contrato_item)"
															rippleEffect *ngIf="row.id_tipo_item == 1"> Chips
															<i data-feather="arrow-right" class="mr-25"></i>
														</button>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

									</ngx-datatable>
								</div>
							</section>
						</div>
					</div>

				</div>

				<div class="col-xl-3 col-md-4 col-12 mt-md-0 mt-2">
					<div class="card">
						<div class="card-body">
							<button routerLink="/contrato/" class="btn btn-outline-primary btn-block mb-75 imprimir"
								rippleEffect>
								Voltar
							</button>
							<button (click)="submitForm(cadastroForm)" type="submit"
								[disabled]="contratoInterface.id_status == 2" class="btn btn-primary btn-block mb-75 "
								rippleEffect>
								<span class="align-middle d-sm-inline-block d-none">Salvar</span>
								<span *ngIf="loading"
									class="spinner-border spinner-border-sm align-middle ml-sm-25 ml-0"></span>
							</button>

						</div>
					</div>
				</div>
			</div>
		</section>
	</div>

</div>